import { render } from "./OrderStatusComponent.vue?vue&type=template&id=b4b89f0a"
import script from "./OrderStatusComponent.vue?vue&type=script&lang=js"
export * from "./OrderStatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/OrderStatusComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4b89f0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4b89f0a', __exports__)) {
    api.reload('b4b89f0a', __exports__)
  }
  
  module.hot.accept("./OrderStatusComponent.vue?vue&type=template&id=b4b89f0a", () => {
    api.rerender('b4b89f0a', render)
  })

}


export default __exports__